<template>
  <div class="c-imgarena">
    <div class="c-imgarena__nav">
      <app-tabs
        variant="pills"
        label="Img Arena sections"
        :tabs="navigationTabs"
        :value="selectedTab.key"
        @input="changeSubsection"
      />
    </div>

    <component
      :is="selectedTab.component"
      :key="selectedTab.key"
    />
  </div>
</template>

<script>

import {PERMISSION_NAMES} from "@/const/online-permissions";
import {onlinePermissionsMixin} from "@/mixins/onlinePermissionsMixin";
import {validationBaseMixin} from '@/mixins/ValidationBaseMixin';
import ImgArenaPairs from "@/pages/on-line/configurations/components/img-arena/img-arena-pairs/index.vue";
import InfrontPairs from "@/pages/on-line/configurations/components/img-arena/infront-pairs/index.vue";
import StreamConfig from "@/pages/on-line/configurations/components/img-arena/stream-config/index.vue";
import StatsPerformPairs from "@/pages/on-line/configurations/components/img-arena/stats-perform-pairs/index.vue";
import AppTabs from "@/shared/app-tabs/AppTabs";


export default {
  name: "ImgArenaConfiguration",

  components: {
    ImgArenaPairs,
    InfrontPairs,
    StreamConfig,
    StatsPerformPairs,
    AppTabs,
  },

  mixins: [onlinePermissionsMixin, validationBaseMixin],

  data() {
    return {
      selectedTab: {
        name: 'IMG Arena pairs',
        key: 'imgarena-pairs',
        component: 'ImgArenaPairs',
      },
      availableSubsections: [
        {
          name: 'Configuration',
          key: 'configuration',
          component: 'StreamConfig',
        },
        {
          name: 'IMG Arena pairs',
          key: 'imgarena-pairs',
          component: 'ImgArenaPairs',
        },
        {
          name: 'Infront pairs',
          key: 'infront-pairs',
          component: 'InfrontPairs',
        },
        {
          name: 'Stats Perform pairs',
          key: 'stats-perform-pairs',
          component: 'StatsPerformPairs',
        }
      ],
    }
  },

  computed: {
    PERMISSION_NAMES() {
      return PERMISSION_NAMES
    },

    navigationTabs() {
      return this.availableSubsections.map(({ key, name }) => ({ key, label: name }));
    },
  },

  methods: {
    changeSubsection(key) {
      this.selectedTab = this.availableSubsections.find(subsection => subsection.key === key);
    }
  }
};
</script>

<style lang="scss" scoped>
.c-imgarena {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.c-imgarena__nav {
  padding-bottom: 16px;
}
</style>
<script setup>
</script>
